import React, { useState, useRef, useEffect } from 'react';

import { useDispatch } from 'react-redux';
import { tempoTemporizador } from '../../../../store/modules/temporizador/actions';

export const Cronometro = ({ tempoAtual, tempoTotal }) => {
  const Ref = useRef(null);
  const [timer, setTimer] = useState(tempoAtual);
  const dispatch = useDispatch();

  const getTimeRemaining = (e) => {
    const total = Date.parse(e) - Date.parse(new Date());
    const seconds = Math.floor((total / 1000) % 60);
    const minutes = Math.floor((total / 1000 / 60) % 60);
    const hours = Math.floor(((total / 1000) * 60 * 60) % 24);
    return {
      total,
      hours,
      minutes,
      seconds,
    };
  };

  const startTimer = (e) => {
    const { total, hours, minutes, seconds } = getTimeRemaining(e);
    if (total >= 0) {
      setTimer(
        `${hours > 9 ? hours : `0${hours}`}:${
          minutes > 9 ? minutes : `0${minutes}`
        }:${seconds > 9 ? seconds : `0${seconds}`}`
      );
    }
  };

  const clearTimer = (e) => {
    if (Ref.current) clearInterval(Ref.current);
    const id = setInterval(() => {
      startTimer(e);
    }, 1000);
    Ref.current = id;
  };

  const getDeadTime = () => {
    const deadline = new Date();
    deadline.setSeconds(deadline.getSeconds() + tempoTotal);
    return deadline;
  };

  useEffect(() => {
    clearTimer(getDeadTime());
  }, []);

  useEffect(() => {
    const params = {
      tempo: timer,
      situacao: timer === '00:00:00' ? 'finalizado' : 'executando',
    };
    dispatch(tempoTemporizador(params));
  }, [timer, dispatch]);

  return <span>{timer}</span>;
};
